import { ReactNode, useMemo } from 'react';
import BrowserRecommendation from './pages/status-page/browser-recommendation';
// import DeviceRecommendation from './pages/status_page/DeviceRecommendation';

export default function ProtectedBrowser({
  children,
}: {
  children: ReactNode;
}) {
  const browserName = useMemo(() => {
    if (typeof window === 'undefined') return 'Other';

    const { userAgent } = navigator;

    if (/CriOS/.test(userAgent)) return 'Chrome IOS';
    // if (/FxiOS/.test(userAgent)) return 'Firefox IOS';
    if (/EdgiOS/.test(userAgent)) return 'Edge IOS';
    if (/OPiOS/.test(userAgent)) return 'Opera IOS';

    if (/OPR/.test(userAgent)) return 'Opera';
    if (/Chrome/.test(userAgent) && !/Edg|OPR|Brave/.test(userAgent)) {
      return 'Chrome';
    }
    if (/Edg/.test(userAgent)) return 'Edge';
    // if (/Firefox/.test(userAgent)) return 'Firefox';

    return 'Other';
  }, []);

  // const isDesktopDevice = useMemo(() => {
  //   if (typeof window === 'undefined') return false;

  //   const { userAgent } = navigator;

  //   // Check for mobile/tablet devices
  //   const isMobile =
  //     /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
  //       userAgent
  //     );

  //   // Additional check for screen size (typical tablet/mobile breakpoint)
  //   // const isSmallScreen = window.innerWidth <= 1024;

  //   return !isMobile;
  // }, []);

  // if (!isDesktopDevice) {
  //   return <DeviceRecommendation />;
  // }

  return browserName === 'Other' ? <BrowserRecommendation /> : <>{children}</>;
}
